import {
  AbsoluteCenter,
  Box,
  chakra,
  Checkbox,
  Flex,
  Image,
  shouldForwardProp,
} from "@chakra-ui/react";
import { isValidMotionProp, motion } from "framer-motion";
import { COMMON_WEB_PATH } from "../../../../constant";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useTransferInGameHandler } from "./transferInGameHandler";
import i18next from "i18next";

const ChakraBox = chakra(motion.div, {
  shouldForwardProp: (prop) =>
    isValidMotionProp(prop) || shouldForwardProp(prop),
});

/**
 * @description 遊戲中轉點Modal
 * @param {function} onClose - 關閉Modal的函數
 * @returns
 */
const TransferInGameModal = ({ onClose } = {}) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);

  const { handleTransferAllIn } = useTransferInGameHandler();

  const [isChecked, setIsChecked] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);

  const handleChecked = (e) => {
    setIsChecked(e.target.checked);
  };

  const handleConfirm = async () => {
    if (!isChecked) return;

    setButtonLoading(true);

    await handleTransferAllIn({
      handleCancel,
      setButtonLoading,
    });
  };

  const handleCancel = async () => {
    onClose();
  };

  return (
    <Flex
      position="fixed"
      top="0"
      left="0"
      right="0"
      bottom="0"
      bg="rgba(0, 0, 0, 0.8)"
      zIndex="99999"
      backdropFilter="blur(2px)"
      justifyContent="center"
      alignItems="center"
    >
      <ChakraBox
        as={Flex}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3, delay: 0.3 }}
        w="420px"
        minH="300px"
        bgImage={`url('${COMMON_WEB_PATH}/now888/modal/hintBG.webp')`}
        bgPosition="center"
        bgRepeat="no-repeat"
        bgSize="100% 100%"
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        position={"relative"}
        p={6}
        pt={"50px"}
      >
        <AbsoluteCenter
          display="flex"
          fontSize="24px"
          color="white"
          textAlign="center"
          mt={4}
          // bgImage={`url('${COMMON_WEB_PATH}/flyDragon/hintTitleBG.webp')`}
          bgPosition="center"
          bgRepeat="no-repeat"
          bgSize="100% 100%"
          sx={{ width: "-webkit-fill-available" }}
          justifyContent="center"
          alignItems="center"
          top="-30px"
        >
          <Image
            src={`${COMMON_WEB_PATH}/now888/modal/hintWORD${
              i18next.language == "tw" ? "" : `_${i18next.language}`
            }.webp`}
            height={{
              base: "50px",
              xl: "60px",
            }}
          />
        </AbsoluteCenter>
        <Box
          position="absolute"
          top="0"
          right="0"
          w="60px"
          h="30px"
          onClick={handleCancel}
          cursor="pointer"
        ></Box>
        <Box
          flex={1}
          alignItems={"center"}
          fontSize="24px"
          fontWeight={"bold"}
          color="white"
          textAlign="center"
          display="flex"
          mb={2}
        >
          {i18n(
            "1.轉點期間請勿投注。若失敗將自動重試，無法成功時會將點數退回您的錢包"
          )}
          <br />
          {i18n("2.遊戲裡面的餘額若為0，入鈔成功後必須重新進入遊戲")}
        </Box>

        <Flex gap={4} mt={3} mb={3} justifyContent="center" alignItems="center">
          <Flex
            as="button"
            w="165px"
            h="60px"
            bgImage={`url('${COMMON_WEB_PATH}/now888/button/confirm_background.png')`}
            bgPosition="center"
            bgRepeat="no-repeat"
            bgSize="100% 100%"
            justifyContent="center"
            alignItems="center"
            _hover={{ filter: "brightness(1.1)" }}
            onClick={handleConfirm}
            opacity={isChecked && !buttonLoading ? 1 : 0.5}
            filter={isChecked && !buttonLoading ? "none" : "grayscale(1)"}
            cursor={isChecked && !buttonLoading ? "pointer" : "not-allowed"}
          >
            <Image
              src={`${COMMON_WEB_PATH}/now888/button${
                i18next.language == "tw" ? "" : `/${i18next.language}`
              }/confirm_text.png`}
              width="70px"
              height={{
                base: "30px",
                xl: "30px",
              }}
            />
          </Flex>
          <Flex
            as="button"
            w="165px"
            h="60px"
            bgImage={`url('${COMMON_WEB_PATH}/now888/button/cancel_background.png')`}
            bgPosition="center"
            bgRepeat="no-repeat"
            bgSize="100% 100%"
            cursor="pointer"
            justifyContent="center"
            alignItems="center"
            onClick={handleCancel}
            _hover={{ filter: "brightness(1.1)" }}
          >
            <Image
              src={`${COMMON_WEB_PATH}/now888/button${
                i18next.language == "tw" ? "" : `/${i18next.language}`
              }/cancel_text.png`}
              width="70px"
              height={{
                base: "30px",
                xl: "30px",
              }}
            />
          </Flex>
        </Flex>
        <Checkbox
          isChecked={isChecked}
          name="remember_account"
          onChange={handleChecked}
          color={"#e495ff"}
          mb="10px"
        >
          {i18n("我瞭解了")}
        </Checkbox>
      </ChakraBox>
    </Flex>
  );
};

export default TransferInGameModal;
